import { Row } from 'components/Calendar/styled'
import styled from 'styled-components'

export const WeekRow = styled(Row)``
